import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import ProductCard from "../components/ProductCard";

const CATEGORIES = [
  { slug: null, label: "Tutto" },
  { slug: "borse", label: "Borse" },
  { slug: "accessori", label: "Accessori" },
  { slug: "abbigliamento", label: "Abbigliamento" },
];

export default function Shop() {
  const { category } = useParams();
  const nav = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = category ? { category } : {};
    api.get("/products", { params })
      .then((r) => setProducts(r.data))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, [category]);

  const title = category
    ? CATEGORIES.find((c) => c.slug === category)?.label || "Shop"
    : "La collezione";

  return (
    <div data-testid="shop-page" className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16">
      <div className="max-w-2xl">
        <span className="overline">Shop</span>
        <h1 className="font-serif text-5xl sm:text-6xl mt-4 tracking-tight">{title}</h1>
        <p className="text-sm text-alimi-inkSoft mt-5 leading-relaxed">
          Esplora le nostre creazioni: ogni pezzo è realizzato a mano, in tiratura limitata.
        </p>
      </div>

      {/* Filter pills */}
      <div className="flex flex-wrap gap-3 mt-10 border-b border-alimi-border pb-6">
        {CATEGORIES.map((c) => {
          const active = (c.slug || null) === (category || null);
          return (
            <button
              key={c.label}
              data-testid={`filter-${c.slug || "all"}`}
              onClick={() => nav(c.slug ? `/shop/${c.slug}` : "/shop")}
              className={`px-5 py-2 text-[0.72rem] tracking-[0.2em] uppercase border transition-all ${
                active
                  ? "bg-alimi-ink text-alimi-bg border-alimi-ink"
                  : "border-alimi-border text-alimi-inkSoft hover:border-alimi-ink hover:text-alimi-ink"
              }`}
            >
              {c.label}
            </button>
          );
        })}
      </div>

      {/* Grid */}
      <div className="mt-12">
        {loading ? (
          <div className="text-center py-20 text-alimi-inkSoft text-sm">Caricamento…</div>
        ) : products.length === 0 ? (
          <div className="text-center py-20 text-alimi-inkSoft">
            <div className="font-serif text-2xl">Nessun prodotto disponibile</div>
            <p className="text-sm mt-3">Torna presto: nuove creazioni in arrivo.</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-12">
            {products.map((p, i) => <ProductCard key={p.id} product={p} idx={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
